/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import React from 'react';

import {useSkipStep} from 'hooks';

import Optional from './Optional';
import {logKycFirebaseEvent} from 'utils';
import {KYC_FIREBASE_EVENTS} from 'constants/kycFirebaseEvents';

const OptionalContainer = ({updateStatus, handleSkipStep, skipStep, flow}) => {
  const {skipStep: handleSkip, isLoading} = useSkipStep();

  const onSkip = () => {
    handleSkip(updateStatus);
    logKycFirebaseEvent(flow, KYC_FIREBASE_EVENTS.NOMINATION_COMPLETED, {
      nomineeStatus: 'skipped',
    });
  };

  return <Optional handleSkip={onSkip} isLoading={isLoading} handleSkipStep={handleSkipStep} />;
};

export default OptionalContainer;
